dialogs-approved-nextstep
  .modal.fade.show(role="dialog")
    .modal-dialog.modal-sm(role="document")
      .modal-content
        .modal-header
          h4.modal-title
            | { opts.title }
          button.close(aria-label="Close" data-dismiss="modal" type="button")
            span(aria-hidden="true")  ×
        .modal-body
          | { opts.body }
        .modal-footer
          button.btn.btn-default.waves-effect(data-dismiss="modal" type="button") Cancel
          forms-dialogs-approved-nextstep(tag-scope="forms_dialogs_approved_nextstep")
  script(type="typescript").
    this.mixin('base');
    this.watch();
